import { AbilityBuilder } from '@casl/ability';
import sectionsAndPages from '../../sectionsAndPages';
import commonActions from '../abilityActions';
import { isInRole } from '../abilityHelpers';
import userRoles from '../userRoles';

const { accounting } = sectionsAndPages;

export default function getRules(user) {
  const { rules, can } = AbilityBuilder.extract();
  const { navigateTo } = commonActions;
  const { accountant, admin } = userRoles;

  if (isInRole(user, [accountant, admin])) {
    can(navigateTo, accounting);
  }

  return rules;
}
